export default [
  {
    name: 'dashboard',
    icon: 'dash',
    path: '/admin/overview',
    custom_permission: '',
    hide_for_users: false,
    hide_for_admin_location: false,
    hide_for_marketer: true,
    hide_for_operator: true
  },
  // {
  //   name: 'Ordering Management',
  //   icon: 'ti-pencil-alt',
  //   path: '/ordering-management'
  // },
  {
    name: 'customers',
    icon: 'cust',
    path: '/customers',
    custom_permission: 'general_can_access_clients',
    hide_for_users: false,
    hide_for_admin_location: false,
    hide_for_marketer: false,
    hide_for_operator: true
    // children: [{
    //   path: '/customers',
    //   name: 'customers',
    //   hide_for_users: false,
    //   hide_for_admin_location: false
    // },
    // {
    //   path: '/groups',
    //   name: 'customersGroups',
    //   hide_for_users: false,
    //   hide_for_admin_location: false
    // }]
  },
  // {
  //   name: 'Info Pages',
  //   icon: 'ti-info',
  //   path: '/info-pages'
  // },
  {
    name: 'orders',
    icon: 'order',
    path: '/orders',
    custom_permission: 'general_can_access_orders',
    session: 'newOrders',
    hide_for_users: false,
    hide_for_marketer: true,
    hide_for_operator: true
  },
  {
    name: 'catalog',
    icon: 'catalog',
    path: '/catalog?tabIndex=0',
    custom_permission: 'general_can_access_catalog',
    activePaths: [
      '/catalog',
      '/products',
      '/categories',
      '/top-categories',
      '/product-options',
      '/group-options',
      '/product-filters',
      '/custom-info-pages',
      '/menu-links',
      '/info-pages'
    ],
    hide_for_users: true,
    hide_for_admin_location: false,
    hide_for_marketer: false,
    hide_for_operator: true
    // children: [{
    //   name: 'products',
    //   path: '/products',
    //   hide_for_users: true,
    //   hide_for_admin_location: false
    // },
    // {
    //   name: '',
    //   path: '/product/add',
    //   hide_for_users: true,
    //   hide_for_admin_location: true,
    //   hide_for_marketer: false,
    //   hide_for_operator: true
    // },
    // {
    //   name: '',
    //   path: '/product/edit',
    //   isRoute: false,
    //   hide_for_users: true,
    //   hide_for_admin_location: true,
    //   hide_for_marketer: false,
    //   hide_for_operator: true
    // },
    // {
    //   name: 'categories',
    //   path: '/categories',
    //   hide_for_users: true,
    //   hide_for_admin_location: true,
    //   hide_for_marketer: false,
    //   hide_for_operator: true
    // },
    // {
    //   name: '',
    //   path: '/category/add',
    //   hide_for_users: true,
    //   hide_for_admin_location: true,
    //   hide_for_marketer: false,
    //   hide_for_operator: true
    // },
    // {
    //   name: 'topCategory',
    //   nameshort: 'TC',
    //   path: '/top-categories',
    //   hide_for_users: true,
    //   hide_for_admin_location: true,
    //   hide_for_marketer: false,
    //   hide_for_operator: true
    // },
    // {
    //   name: 'productOptions',
    //   nameshort: 'PO',
    //   path: '/product-options',
    //   hide_for_users: true,
    //   hide_for_admin_location: true,
    //   hide_for_marketer: false,
    //   hide_for_operator: true
    // },
    // {
    //   name: 'groupOptions',
    //   nameshort: 'GO',
    //   path: '/group-options',
    //   hide_for_users: true,
    //   hide_for_admin_location: true,
    //   hide_for_marketer: false,
    //   hide_for_operator: true
    // },
    // {
    //   name: 'productFilters',
    //   nameshort: 'PF',
    //   path: '/product-filters',
    //   hide_for_users: true,
    //   hide_for_admin_location: true,
    //   hide_for_marketer: false,
    //   hide_for_operator: true
    // },
    // {
    //   name: '',
    //   path: '/top-category/add',
    //   hide_for_users: true,
    //   hide_for_admin_location: true,
    //   hide_for_marketer: false,
    //   hide_for_operator: true
    // },
    // {
    //   name: '',
    //   path: '/top-category/edit',
    //   hide_for_users: true,
    //   hide_for_admin_location: true,
    //   hide_for_marketer: false,
    //   hide_for_operator: true
    // },
    // {
    //   name: 'infoPagesCustom',
    //   nameshort: 'CP',
    //   path: '/custom-info-pages',
    //   hide_for_users: true,
    //   hide_for_admin_location: true,
    //   hide_for_marketer: false,
    //   hide_for_operator: true
    // },
    // {
    //   name: 'menuLinks',
    //   nameshort: 'ML',
    //   path: '/menu-links',
    //   hide_for_users: true,
    //   hide_for_admin_location: true,
    //   hide_for_marketer: false,
    //   hide_for_operator: true
    // },
    // {
    //   name: 'infoPages',
    //   nameshort: 'IP',
    //   path: '/info-pages',
    //   hide_for_users: true,
    //   hide_for_admin_location: true,
    //   hide_for_marketer: false,
    //   hide_for_operator: true
    // }
    // ]
  },
  {
    name: 'tables',
    icon: 'tables',
    path: '/tables',
    custom_permission: 'general_can_access_tables',
    session: 'newTables',
    hide_for_users: true,
    hide_for_marketer: true,
    hide_for_operator: true,
    disabled_globally: true
  },
  {
    name: 'reservations',
    icon: 'reservations',
    path: '/reservations',
    custom_permission: 'general_can_access_reservations',
    session: 'newReservations',
    hide_for_users: true,
    hide_for_marketer: true,
    hide_for_operator: true
  },
  {
    name: 'orderspos',
    icon: 'ordernew',
    path: '/add-order',
    custom_permission: 'general_can_access_add_order',
    hide_for_users: true,
    hide_for_marketer: true,
    hide_for_operator: true
  },
  {
    name: 'dispatch',
    icon: 'dispatch',
    path: '/dispatch?tabIndex=0',
    custom_permission: 'general_can_access_dispatch',
    hide_for_users: true,
    hide_for_admin_location: false,
    hide_for_marketer: true,
    hide_for_operator: true,
    disabled_globally: true
  },
  {
    name: 'online',
    icon: 'online',
    path: '/online?tabIndex=0',
    hide_for_users: false,
    hide_for_admin_location: false,
    hide_for_marketer: true,
    hide_for_operator: true,
    disabled_globally: true
  },
  {
    name: 'kiosk',
    icon: 'kiosk',
    path: '/kiosk?tabIndex=0',
    hide_for_users: false,
    hide_for_admin_location: false,
    hide_for_marketer: true,
    hide_for_operator: true,
    disabled_globally: true
  },
  {
    name: 'qr',
    icon: 'qr',
    path: '/qr?tabIndex=0',
    hide_for_users: false,
    hide_for_admin_location: false,
    hide_for_marketer: true,
    hide_for_operator: true,
    disabled_globally: true
  },
  {
    name: 'kds',
    icon: 'kds',
    path: '/screens/kds?tabIndex=0',
    custom_permission: 'general_can_access_kds',
    hide_for_users: true,
    hide_for_admin_location: false,
    hide_for_marketer: true,
    hide_for_operator: true,
    disabled_globally: true
  },
  {
    name: 'screens',
    icon: 'screens',
    path: '/screens/tabs?tabIndex=0',
    custom_permission: 'general_can_access_screens',
    activePaths: [
      { path: '/screens', exact: true },
      '/screens/tabs'
    ],
    exact: true,
    includeChildrenInActive: false,
    hide_for_users: true,
    hide_for_admin_location: false,
    hide_for_marketer: true,
    hide_for_operator: true,
    disabled_globally: true
  },
  {
    name: 'gestiune',
    icon: 'gestiune',
    path: '/management/sidebar?tab=reports',
    custom_permission: 'general_can_access_inventory',
    hide_for_users: true,
    hide_for_admin_location: false,
    hide_for_marketer: true,
    hide_for_operator: true,
    disabled_globally: true
  },
  {
    name: 'pos',
    icon: 'pos',
    path: '/pos/tabs?tabIndex=1',
    custom_permission: 'general_can_access_pos',
    hide_for_users: true,
    hide_for_admin_location: false,
    hide_for_marketer: true,
    hide_for_operator: true,
    disabled_globally: true
  },
  {
    name: 'marketing',
    icon: 'marketing',
    path: '/marketing',
    custom_permission: 'general_can_access_marketing',
    hide_for_users: true,
    hide_for_admin_location: false,
    hide_for_marketer: false,
    hide_for_operator: true,
    disabled_globally: true
    // children: [{
    //   path: '/marketing/campaigns',
    //   name: 'campaigns',
    //   hide_for_admin_location: true
    // },
    // {
    //   path: '/marketing/offers',
    //   name: 'offersSlider',
    //   nameshort: 'OS',
    //   hide_for_admin_location: true
    // },
    // {
    //   path: '/marketing/fidelities',
    //   name: 'fidelities',
    //   nameshort: 'F',
    //   hide_for_admin_location: true
    // },
    // {
    //   path: '/marketing/promos',
    //   name: 'promos',
    //   nameshort: 'PR'
    // },
    // {
    //   path: '/marketing/dynamic-menus',
    //   name: 'menus',
    //   hide_for_admin_location: true
    // }]
  },
  // {
  //   name: 'scanner',
  //   icon: 'scan',
  //   path: '/scanner',
  //   custom_permission: 'general_can_access_scan',
  //   hide_for_users: false,
  //   hide_for_marketer: true,
  //   hide_for_operator: false
  // },
  {
    name: 'reports',
    icon: 'report',
    path: '/reports',
    custom_permission: 'general_can_access_reports',
    hide_for_users: false,
    hide_for_admin_location: false,
    hide_for_marketer: true,
    hide_for_operator: true
  },
  {
    icon: 'feedback',
    name: 'feedback',
    path: '/feedback',
    custom_permission: 'general_can_access_feedback',
    session: 'newFeedback',
    hide_for_users: false,
    hide_for_admin_location: false,
    hide_for_marketer: true,
    hide_for_operator: true
  },
  {
    name: 'settings',
    icon: 'settings',
    path: '/settings',
    custom_permission: 'general_can_access_setings',
    hide_for_users: true,
    hide_for_admin_location: true,
    hide_for_marketer: true,
    hide_for_operator: true
    // children: [
    //   {
    //     name: 'General',
    //     path: '/settings'
    //   },
    //   {
    //     name: 'Users',
    //     path: '/users'
    //   }
    // ]
  },
  // {
  //   name: 'payment',
  //   icon: 'payment',
  //   path: '/payment',
  //   custom_permission: 'general_can_access_pay',
  //   hide_for_users: true,
  //   hide_for_admin_location: true,
  //   hide_for_marketer: true,
  //   hide_for_operator: true,
  //   hide_bills: true
  // },
  {
    name: 'newsletter',
    icon: 'newsletter',
    path: '/newsletter/news',
    session: 'newNews',
    hide_for_users: true,
    hide_for_admin_location: true,
    hide_for_marketer: true,
    hide_for_operator: true
  }
]



// WEBPACK FOOTER //
// ./src/sidebarLinks.js